import React from "react"
import { Link } from 'react-router-dom'

const CardItem = (props) => {
  const {devInfo} = props;
  //console.log(devInfo)

  return (
    <>
        <div className="col-md-4 d-flex" key={devInfo.id}>
            <div className="card mb-4 box-shadow flex-fill">
                <div className="device-card d-flex flex-column">
                    <div className="device-temp-value"> {`
                    ${devInfo.temperature ? devInfo.temperature : '--.-'}
                    `} °C</div>
                    <div className="device-hum-value"> {`
                    ${devInfo.humidity ? devInfo.humidity : '--.-'}
                    `} %</div>
                </div>
                <div className="card-body d-flex flex-column">
                    <p className="card-text">Dev #{devInfo.id}, {devInfo.name}</p>
                    <div className="d-flex justify-content-between align-items-center mt-auto">
                        <div className="btn-group">
                            <Link to={`/selected_device/${devInfo.id}`}>
                                <button type="button" className="btn btn-sm btn-outline-secondary">Details</button>
                            </Link>
                        </div>
                        <small className="text-muted">{devInfo.minutes_left} mins ago</small>
                    </div>
                </div>
            </div>
        </div>
    </>
);
}

export default CardItem